export class IdeActivity {
  public Icon: string;

  public IconSet: string;

  public Lookup: string;

  public Title: string;
}
